import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchQuizCategories, type QuizMeta } from '../../lib/quizData';
import { trackEvent, WEB_QUIZ_LOCKED_VIEW } from '../../lib/analytics';
import { useSEO } from '../../hooks/useSEO';
import { Chip } from '../../components/shared/Chip';
import { ScriptText } from '../../components/shared/ScriptText';
import { StoreBadges } from '../../components/shared/StoreBadges';
import quizBg from '../../assets/images/quiz-bg.png';
import girlImg from '../../assets/images/girl.png';
import manImg from '../../assets/images/man.png';
import styles from './QuizLocked.module.css';

const FEATURES = [
  { label: '6 intimate quizzes', icon: '🔥' },
  { label: 'Dares: Soft to Hardcore', icon: '🎯' },
  { label: 'Sex Bucket List', icon: '✅' },
  { label: 'Roleplay stories for two', icon: '📖' },
];

export function QuizLocked() {
  const { quizId } = useParams<{ quizId: string }>();
  const [meta, setMeta] = useState<QuizMeta | null>(null);
  const [firstFreeId, setFirstFreeId] = useState<string | null>(null);

  useEffect(() => {
    fetchQuizCategories().then((cats) => {
      const found = cats.find((c) => c.id === quizId);
      setMeta(found ?? null);
      const free = cats.find((c) => !c.isLocked);
      setFirstFreeId(free?.id ?? null);
    });
  }, [quizId]);

  useEffect(() => {
    if (quizId) {
      void trackEvent(WEB_QUIZ_LOCKED_VIEW, { quiz_id: quizId });
    }
  }, [quizId]);

  useSEO({
    title: meta ? `${meta.name} — Unlock in App` : 'Unlock Quiz in App',
    description: meta
      ? `Download LuvLust to unlock ${meta.name} and 200+ more intimate questions. Build your Sex Bucket List together.`
      : 'Download LuvLust to unlock all couple quizzes.',
  });

  return (
    <div className={styles.page} style={{ backgroundImage: `url(${quizBg})` }}>
      <div className={styles.overlay} />

      <div className={styles.layout}>
        <img src={girlImg} alt="" className={styles.sideImg} />

        <div className={styles.center}>
          <div className={styles.lockIcon}>🔒</div>
          <Chip>{meta?.name ?? 'Locked Quiz'}</Chip>

          <h1 className={`display ${styles.heading}`}>
            This one's in<br />the <ScriptText rotate={-2}>app.</ScriptText>
          </h1>

          {meta && (
            <p className={styles.desc}>
              Download LuvLust to unlock {meta.name} and 200+ more intimate
              questions. Build your Sex Bucket List together.
            </p>
          )}

          <div className={styles.features}>
            {FEATURES.map((f) => (
              <div key={f.label} className={styles.featureCard}>
                <span className={styles.featureIcon}>{f.icon}</span>
                <span className={styles.featureLabel}>{f.label}</span>
              </div>
            ))}
          </div>

          <StoreBadges className={styles.badges} analyticsLocation="quiz_locked" />

          {firstFreeId && (
            <Link to={`/quiz/${firstFreeId}`} className={styles.freeLink}>
              ♥ Play a free quiz first
            </Link>
          )}
        </div>

        <img src={manImg} alt="" className={styles.sideImg} />
      </div>
    </div>
  );
}
